export default __webpack_public_path__ + "static/media/logo.c03a937d.svg";